import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  const link = { fontFamily: "'Open Sans', sans-serif", fontSize: 12, color: '#5A6458', textDecoration: 'none' };
  const hover = e => e.currentTarget.style.color = '#85BB65';
  const out   = e => e.currentTarget.style.color = '#5A6458';

  return (
    <footer style={{ background: '#1A1E1A', padding: '56px 24px 36px', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
        <Logo size={72} showText={true} textBelow={true} light={true} />
      </div>

      <p style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 13, color: '#4A5448', maxWidth: 440, margin: '0 auto 28px', lineHeight: 1.7 }}>
        A loyalty platform built for UK businesses and their customers. Simple points, one account, every store.
      </p>

      {/* Contact */}
      <div style={{ marginBottom: 24 }}>
        <a href="mailto:hello@korunto.com" style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 14, color: '#85BB65', textDecoration: 'none', letterSpacing: '0.01em' }}
          onMouseOver={e => e.currentTarget.style.color = '#9FCC75'}
          onMouseOut={e => e.currentTarget.style.color = '#85BB65'}>
          hello@korunto.com
        </a>
      </div>

      {/* Nav links */}
      <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
        <a href={`${process.env.REACT_APP_APP_URL || 'https://api.korunto.com'}/customer.html`} style={link} onMouseOver={hover} onMouseOut={out}>Customer login</a>
        <a href={`${process.env.REACT_APP_APP_URL || 'https://api.korunto.com'}/vendor.html`}   style={link} onMouseOver={hover} onMouseOut={out}>Vendor portal</a>
        <a href="/#about"   style={link} onMouseOver={hover} onMouseOut={out}>About us</a>
      </div>

      <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 28 }}>
        <Link to="/privacy" style={link} onMouseOver={hover} onMouseOut={out}>Privacy Policy</Link>
        <Link to="/terms"   style={link} onMouseOver={hover} onMouseOut={out}>Terms of Service</Link>
      </div>

      <div style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 11, color: '#2E3530' }}>© 2026 Korunto Ltd. All rights reserved.</div>
    </footer>
  );
}
